// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle-" + {"727":"1851caedd7c6b655f45c","798":"f4e17cee8d0aac8c6c1c","890":"5f92998ab902fbaf2f86"}[chunkId] + ".min.js";
};